export const EMAIL = "email";
export const EMAIL_MODULE = "emailModule";
export const EMAIL_TEMPLATE = "emailTemplate";
export const IMAGE = "image";
export const CAMPAIGN = "campaign";
